import { render } from "./FeedbackSuccessErrorPopup.vue?vue&type=template&id=0ad66d8f&scoped=true"
import script from "./FeedbackSuccessErrorPopup.vue?vue&type=script&lang=js"
export * from "./FeedbackSuccessErrorPopup.vue?vue&type=script&lang=js"

import "./FeedbackSuccessErrorPopup.vue?vue&type=style&index=0&id=0ad66d8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad66d8f"]])

export default __exports__